import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Zahlungsmethoden',
  payment_options: {
    [PaymentMethod.Card]: 'Kreditkarte',
  },
};
